import { Errors } from "@/app/Errors";
import { GemmaError } from "@gemma/errors";
import { IVue } from "./mixins/IVue";
import { WebApplicationConstants } from "../setup/WebApplicationConstants";
import { report } from "@/utils";

export async function globalErrorHandler(error: GemmaError | Error, vm: IVue, info: string) {
  // let handler,
  //   current = vm;
  // if (vm && vm.$options && vm.$options.errorHandler) {
  //   handler = vm.$options.errorHandler;
  // } else {
  //   while (current && current.$parent) {
  //     current = current.$parent;
  //     if (current && current.$options && (handler = current.$options.errorHandler)) {
  //       break;
  //     }
  //   }
  // }

  // if (handler) {
  //   handler.call(current, error, vm, info);
  // } else if (error) {
  const vueError = new GemmaError("Vue error: " + error.message, { innerError: error, data: { isSourceVue: true, info, route: vm && vm.$router ? vm.$router.currentRoute.fullPath : window.location.toString() } });
  if (vm) {
    if (vm.errors) {
      vm.errors.push(Errors.UnhandledError(vueError.id));
    }

    error.message = `(${vm.$options.name}): ${error.message}`;
  }

  await report.error(vueError, WebApplicationConstants.show.errorOverlay);
  // }
}
